import React from "react";
import { Nav, NavLink, NavModule, NavSplit } from "./styles";
import MobileApps from "./MobileApps";
import ShipTo from "./ShipTo";
import Language from "./Language";
import { CUSTOMER_SERVICE } from "../../utils";
import getLangKeyValueFun from "../../../../utils/lang";
import langGroup from "../../../../assets/lang.json";
const getText = getLangKeyValueFun(langGroup);
class HeaderNav extends React.Component {
    constructor() {
        super(...arguments);
        this.onOpenCustomerService = () => {
            window.open(CUSTOMER_SERVICE());
        };
    }
    render() {
        const { countries = [], userCountry, currencies = [], userCurrency, popularCounties = [], languages = [], userLanguage, onChangeLanguage } = this.props;
        return (React.createElement(Nav, null,
            React.createElement(MobileApps, null),
            React.createElement(NavSplit, null),
            React.createElement(NavModule, null,
                React.createElement(NavLink, { onClick: this.onOpenCustomerService, style: { marginRight: 4 } }, getText("Help Center"))),
            React.createElement(NavSplit, null),
            React.createElement(ShipTo, { countries: countries, popularCounties: popularCounties, userCountry: userCountry, currencies: currencies, userCurrency: userCurrency }),
            React.createElement(NavSplit, { style: { marginRight: 18, marginLeft: 14 } }),
            React.createElement(Language, { languages: languages, userLanguage: userLanguage, onChangeLanguage: onChangeLanguage })));
    }
}
export default HeaderNav;
